import { useRouterSlice } from '@gef-ui/context-defaults';
const useRouter = ()=>useRouterSlice('Router');
export default useRouter;
